import { throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class ExceptionService {

    handleError(errorResponse: HttpErrorResponse) {
        // in a real world app, we may send the error to some remote logging infrastructure
        // instead of just logging it to the console
        console.error(errorResponse);
        if (errorResponse.error instanceof Error) {
            console.log('Client-side error occured.');
            throwError(() => errorResponse.error || 'Server error');
        } else {
            console.log('Server-side error occured.');
            throwError(() => errorResponse.error || 'Server-side error occured');
        }
    }
}
